"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./imagebox.css");
var Imagebox = function (props) {
    var id = props.id;
    return (react_1.default.createElement("div", { className: "imagebox-container" },
        react_1.default.createElement("h3", null,
            "TBD: Show lightbox for image with id: ",
            id),
        react_1.default.createElement("p", null, "Having issue using Lightbox from react-modal-image because of type.")));
};
exports.default = Imagebox;
